export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const SET_BREADSCRUM = "SET_BREADSCRUM";
export const SET_MENU_WIDTH = "SET_MENU_WIDTH";

export function setCurrentPage(page) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: SET_CURRENT_PAGE, payload: page });
      resolve();
    });
  };
}

export function setBreadscrum(page, paths) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: SET_BREADSCRUM, payload: { page, paths } });
      resolve();
    });
  };
}

export function setMenuWidth(width) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: SET_MENU_WIDTH, payload: width });
      resolve();
    });
  };
}
